import { Button, Container } from "react-bootstrap"
import NavbarComp from "../../shared/components/Navbar"
import { IoAddCircleOutline } from "react-icons/io5"
import ListProductCategoryTable from "./components/ListProductCategoryTable"
import ModalAddListProductCategory from "./components/ModalAddListProductCategory"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useListProductCategory } from "./hooks/useListProductCategory"

const ListProductCategoryPage = () => {

    const {
        addCategoriesProductDetail,
        editCategoriesProductDetail,
        listProductCategory,
        loading,
        error,
        removeCategoriesProductDetail,
        fetchCategoriesProductDetailByIdPaketDetil,
    } = useListProductCategory()

    const location = useLocation();
    const receivedData = location.state;

    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleSend = (data) => {
        addCategoriesProductDetail(data)
    }

    useEffect(() => {
        const interval = setInterval(() => {
            fetchCategoriesProductDetailByIdPaketDetil(receivedData?.row?.id_paket_detil); // Reload products every 5 seconds
        }, 2000);

        return () => clearInterval(interval); // Clear interval on component unmount
    }, [listProductCategory]);

    return (
        <>
            <NavbarComp />
            <Container fluid className="mt-2 mt-md-5">
                <Button Tooltip={"test"}
                    variant="outline-success"
                    className="mb-2"
                    onClick={handleOpenModal}
                >
                    <IoAddCircleOutline size={32} />
                </Button>
                <ListProductCategoryTable
                    listProductCategory={listProductCategory}
                    tittle={receivedData?.row}
                    // onEdit={handleEditProduct}
                    onDelete={removeCategoriesProductDetail}
                // modalAddDetail={showModalAddDetail}
                // onDetail={findOneCategoriesProductByid}
                />
            </Container>
            <ModalAddListProductCategory
                show={showModal}
                handleClose={handleCloseModal}
                dataParsing={receivedData}
                sendData={handleSend}
            />
        </>
    )
}

export default ListProductCategoryPage